import React from "react"

import {Loading} from "../../../../../components/Loading.tsx"

export const tableLoadingIndicator = <Loading size={"sm"} fullSpace={false} />
